import { normalize } from "@/packages/normalizer/normalize";
import { Entity } from "@/shared/Entity";

export class User extends Entity {

    /**
     * Verifica si el usuario tiene el rol pasado como argumento
     * 
     * @param {string} roleNames
     * @returns {boolean} true si el usuario tiene el rol pasado como argumento
     */
    hasRole(...roleNames) {

        if (!this.object || !this.object.roles) {
            return false;
        }

        return this.object.roles.some((role) => {

            // Se valida que el usuario tenga al menos un rol de roleNames
            for (const roleName of roleNames) {

                if (normalize(role.name) === normalize(roleName)) {
                    return true;
                }
            }
            return false;
        });
    }

    hasTermsAccepted() {
        return this.object.terms == true;
    }
}